<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.shipment_customs_code_hscode') || '报关hscode'"
            prop="hscode"
          >
            <dict-select
              v-model="formData.hscode"
              size="small"
              clearable
              filterable
              url="/factory/shipment/customs/code/dictSelect"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_clearanceDuty') || '清关税率'"
            prop="clearanceDuty"
          >
            <el-input-number
              v-model="formData.clearanceDuty"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              :min="0"
              :precision="2"
              :step="1"
              controls-position="right"
              style="width:100%;"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_clearanceHscode') || '清关hscode'"
            prop="clearanceHscode"
          >
            <el-input
              v-model="formData.clearanceHscode"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              size="small"
              maxlength="50"
              clearable
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    shipmentCustomerSettingCode: {type: String, default: ''},
    hscodeSettingCode: {type: String, default: ''},
    params: {type: Object, default: () => {}},
  },
  data() {
    return {
      formData: {},
      rules: {
        clearanceDuty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        clearanceHscode: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        hscode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.hscodeSettingCode) return

      this.$api
        .shipmentCustomerSettingHscodeDetailApi({
          hscodeSettingCode: this.hscodeSettingCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .shipmentCustomerSettingHscodeSaveApi({
          ...this.formData,
          shipmentCustomerSettingCode: this.shipmentCustomerSettingCode,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
